import { useMemo } from 'react';

import { DateRangeChange } from 'ui/datePicker/types';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';

import { AggregateEventInfo, UserKey } from '../../domain';
import { useUserKey } from '../../hooks';

interface UserEventSummaryResponse {
  UserProfileEvents: AggregateEventInfo[];
}

const createUri = (userKey?: UserKey): string | undefined => {
  if (!userKey || userKey.length === 0) {
    return;
  }

  return `/users/profiles/aggregateEvents/${userKey}`;
};

const formatParams = (dateRange?: DateRangeChange): Record<string, unknown> | undefined => {
  if (!dateRange?.startDate || !dateRange?.endDate) {
    return undefined;
  }

  return {
    startTime: dateRange.startDate.valueOf(),
    endTime: dateRange.endDate.valueOf(),
  };
};

export const useEventAggregatesQuery = (dateRange?: DateRangeChange) => {
  const userKey = useUserKey();
  const uri = useMemo(() => createUri(userKey), [userKey]);
  const options = useMemo(() => formatParams(dateRange), [dateRange]);
  return useRestQuery<UserEventSummaryResponse>(uri, options);
};
